/* global google */
import {
  PLACES_SUGGESTION_FETCH_SUCCESS,
  SET_SEARCH_SUGGESTION_TERM,
  SET_SEARCH_SELECTION,
  CLEAR_SEARCH_SUGGESTIONS,
  SET_SEARCH_MARKER,
  SET_SEARCH_FOCUSED,
  SET_SELECTED_LAYER_ELEMENT
} from '../constants/action-types';
import { LOCALITY_INFO, CITY_CENTER_LAT, CITY_CENTER_LNG } from '../constants/google-maps';
import { setCenter, setZoom } from './map-actions';

let placesResultCache = {};

const fetchPlacesSuggestionsSuccess = suggestions => ({
  type: PLACES_SUGGESTION_FETCH_SUCCESS,
  suggestions
});

export const fetchGeocodeSuggestions = (searchValue, map = null, autoCompleteSessionRef = null) => async dispatch => {
  if (!searchValue) {
    dispatch(fetchPlacesSuggestionsSuccess([]));
  }
  const request = {
    input: `${searchValue} ${LOCALITY_INFO}`,
    locationBias: map?.getCenter?.() || {lat: CITY_CENTER_LAT, lng: CITY_CENTER_LNG},
    includedPrimaryTypes: ['street_address', 'street_number', 'intersection', 'geocode', 'premise'],
    language: 'en-US',
    region: 'us',
    sessionToken: autoCompleteSessionRef?.current
  };
  const { suggestions } = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
  placesResultCache = {};
  dispatch(fetchPlacesSuggestionsSuccess(suggestions.map(({placePrediction}) => {
    const place = placePrediction.toPlace();
    placesResultCache[place.id] = place;
    return {
      value: placePrediction.text.toString(),
      label: placePrediction.text.toString(),
      mainText: placePrediction.mainText.toString(),
      secondaryText: placePrediction.secondaryText.toString(),
      placeId: place.id,
      type: 'address'
    };
  })));
};

export const setSearchTermAction = (searchTerm) => ({
  type: SET_SEARCH_SUGGESTION_TERM,
  searchTerm
});

export const setSearchTerm = searchValue => (dispatch) => {
  dispatch(setSearchTermAction(searchValue));
};

export const clearSearchSuggestions = () => ({
  type: CLEAR_SEARCH_SUGGESTIONS
});

const setSearchSelectionSuccess = location => ({
  type: SET_SEARCH_SELECTION,
  location
});

export const setSelectedLayerElement = element => ({
  type: SET_SELECTED_LAYER_ELEMENT,
  element
});

const doSetSearchMarker = visible => ({
  type: SET_SEARCH_MARKER,
  visible
});

const doSetSearchFocused = focused => ({
  type: SET_SEARCH_FOCUSED,
  focused
});

export const setSearchSelection = (searchValue) => async dispatch => {
  if (searchValue.type === 'address') {
    const place = placesResultCache[searchValue.placeId] || new google.maps.places.Place({id: searchValue.placeId});
    if (place) {
      await place.fetchFields({fields: ['location']});
      const location = {
        label: searchValue.mainText,
        value: searchValue.value,
        position: place.location
      };
      if (location) {
        dispatch(setCenter(place.location));
        dispatch(setZoom(17));
        dispatch(setSearchSelectionSuccess(location));
        dispatch(doSetSearchMarker(true));
        dispatch(doSetSearchFocused(false));
      }
    }
  } else {
    dispatch(setSelectedLayerElement(searchValue));
    dispatch(doSetSearchFocused(false));
  }
};

export const clearSearchSelection = () => dispatch => {
  dispatch(setSearchSelectionSuccess(null));
  dispatch(setSelectedLayerElement(null));
};

export const setSearchMarker = visible => dispatch => {
  dispatch(doSetSearchMarker(visible));
};

export const setSearchFocused = focused => dispatch => {
  dispatch(doSetSearchFocused(focused));
};
